export const SIGNAL_FEEDBACK_PATH_NAME = 'signal/feedback';
